// src/components/AdminRoute.jsx
//
// Wrap a route's element in this to ensure only admin users can reach it.
// Non-admins are sent to /dashboard. Unauthenticated users are sent to /
// (the landing page hosts the sign-in form).

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isAdmin } from '../utils/isAdmin';

export default function AdminRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  if (!isAdmin(user)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
